<template lang="pug">
v-app
  section
    header.d-flex.row.flex-row.align-items-center.mb-5
      .col
        h1.m-0.font-italic.d-inline-block.align-middle
          | Histórico&nbsp;
          span.ad_text-secondary {{user.name}}
      .col-2.text-center
        .ad_select.w-100
          select(v-model="year", @change='changeYear($event)')
            option(:value="null" disabled) Selecciona Año
            option(:value="n" v-for="n in years") {{n}}
      .col-2.text-center
        .ad_select.w-100
          select(v-model="month", @change='changeMonth($event)')
            option(:value="null" disabled) Selecciona Mes
            option(:value="n" v-for="n in months") {{meses[n-1]}}

    section
      template
        example-chart(v-if="ready" :id="id" ref="exachart")
      .d-flex.row.flex-row.align-items-start.mt-4
        .col
          .card.p-0.ad_border2-primaryLight.rounded-xl
            .card-body
              b-table.table-simple.no-border(
              show-empty
              stacked="md"
              :items='kpisTableData',
              :fields="fieldsKpi")
              
              template(slot='history', slot-scope='row')
                router-link(:to="{path:'/consultor-externo-historico/'+row.item.id}" title="Historial" append)
                  i.icon.icon-file-stats2
              template(slot='sessions', slot-scope='row')
                //- router-link(:to="{path:'/administracion/'+row.item.id+'/view'}" title="Ver usuario" append)
                i.icon-letters.icon-letters__producto.mr-2(@click="showModal")
              
            .row.mt-5
              .col-auto
                p Total de sesiones:
                  |  {{ totalRowsKpi }}
      hr.my-4
      template
        line-chart-categories(v-if="ready" :id="id" ref="catchart")
      .d-flex.row.flex-row.align-items-start.mt-4
        .col
          .card.p-0.ad_border2-primaryLight.rounded-xl
            .card-body
              b-table.table-simple.no-border(
              show-empty
              stacked="md"
              :items='categoryTableData',
              :fields="fieldsCategories")
              
              template(slot='history', slot-scope='row')
                router-link(:to="{path:'/consultor-externo-historico/'+row.item.id}" title="Historial" append)
                  i.icon.icon-file-stats2
              template(slot='sessions', slot-scope='row')
                //- router-link(:to="{path:'/administracion/'+row.item.id+'/view'}" title="Ver usuario" append)
                i.icon-letters.icon-letters__producto.mr-2(@click="showModal") 
              
            .row.mt-5
              .col-auto
                p Total de sesiones:
                  |  {{ totalRowsCategories }}            
        
             
</template>

<script>
import moment from "moment";
import { mapActions } from "vuex";
import LineChartCategories from '../../components/charts/lineChartCategories';
import ExampleChart from '../../components/charts/exampleChart.vue';

export default {

  name: 'ConsultorHExt',
  components: {
    LineChartCategories,
    ExampleChart
  },
  data () {
    return {
      id: null,
      ready: false,
      user: {},
      year: null,
      years: [],
      month:null,
      months: [],
      weeksNumbers : [],
      collabs : [],
      totals: [],
      meses : [
          "Enero",
          "Febrero",
          "Marzo",
          "Abril",
          "Mayo",
          "Junio",
          "Julio",
          "Agosto",
          "Septiembre",
          "Octubre",
          "Noviembre",
          "Diciembre",
      ],
      asessions: [],
      totalRowsKpi: 0,
      totalRowsCategories: 0,
      fieldsKpi: [
        { key: 'sesion', label: 'Sesion', sortable: true, class: 'text-center'},
        { key: 'epa vggt', label: 'epa vggt', sortable: true, sortDirection: 'desc'},
        { key: 'reiteracion 10 d', label: 'reiteracion 10 d', sortable: true, class: 'text-center'},
        { key: 'vr 24 horas', label: 'vr 24 horas', sortable: true, class: 'text-center'},
        { key: 'produccion', label: 'produccion', sortable: true, class: 'text-center'},
        { key: 'epa vt', label: 'epa vt', sortable: true, class: 'text-center'},
        { key: 'falla temprana', label: 'falla temprana', sortable: true, class: 'text-center'}
      ],
      fieldsCategories: [
        { key: 'sesion', label: 'Sesion', sortable: true, sortDirection: 'desc'},
        { key: 'Claridad', label: 'Claridad', sortable: true, class: 'text-center'},
        { key: 'Comunicación', label: 'Comunicación', sortable: true, sortDirection: 'desc'},
        { key: 'Planificacion Tactica', label: 'Planificacion Tactica', sortable: true, class: 'text-center'},
        { key: 'Control Para la direccion', label: 'Control Para la direccion', sortable: true, class: 'text-center'},
      ],
      chartLineOptions: {
        scales: {
          yAxes: [{
                ticks: {
                    beginAtZero:true
                }
            }],
          xAxes: [{
                ticks: {
                    beginAtZero:true
                }
            }]
        }
      },
      chartLineLabels: [],
      chartLineData: {
        labels: [],
        datasets: []
      },
      chartRadarOptions: {
        indexAxis: 'y',
        scales: {
          y: {
            beginAtZero: true
          },
          x: {
            beginAtZero: true
          }
        }
      },
      chartRadarLabels: ['Claridad', 'Comunicacion', 'Planificación', 'Control'],
      chartRadarData: [
        {data: [20, 10, 25, 15], backgroundColor: "rgba(186,255,201,0.4)"},
        {data: [16, 10, 18, 9], backgroundColor: "rgba(186,225,255,0.4)"}
      ],
      kpisTableData: [],
      categoryTableData: [],
      loaded: false
    }
  },
  methods: {
    moment,
    ...mapActions("user", ["getUserById"]),
    ...mapActions("consultant", ["getAnsweredGuidelinesHistory"]),
    ...mapActions("session", ["userHistorySessions"]),
    getHistorical() {
      const vm = this;
      // const user_evaluated = vm.$store.state.auth.user.id
      vm.categoryTableData = [];
      vm.kpisTableData = [];
      const year = vm.year ? vm.year : 2019;
      const month = vm.month;
      const id = vm.$route.params.id;
      const data = {
        id,
        year, 
        month
      };
      let labels = []
      const loading = vm.$toast.loading("Cargando semanas...");      
      vm.userHistorySessions(data).then(response => {
        vm.asessions = response.message;
        let object = {};
        let objectKpi = {};
        let i = 1;
        for (let s of vm.asessions) {
          object = {};
          object['sesion'] = i;
          // vm.chartLineData.labels.push(s.name);
          labels.push(s.name);
          for (let k of s.kpiext_values) {
            object[k.name] = k.value;
            if (i == 1) {
              // objectKpi['label'] = k.name;
              objectKpi['data'] = [k.value];
            }
          }
          vm.kpisTableData.push(object);
          i++;
        }
        i = 1;
        vm.totalRowsKpi = vm.kpisTableData.length
        let objectC = {};
        for (let s of vm.asessions) {
          objectC = {};
          objectC['sesion'] = i; 
          for (let g of s.results) {
            objectC[g.category_name] = g.total_value;
          }
          vm.categoryTableData.push(objectC);
          i++;
        }
        vm.totalRowsCategories = vm.categoryTableData.length
        vm.chartLineData.labels = labels;
      });
      vm.loaded = true;
      vm.ready = true;
      loading.hide();
    },
    changeYear($event) {
      const vm = this;
      vm.getMonths();
      vm.getHistorical();
    },
    changeMonth($event) {
      const vm = this;
      vm.$refs.exachart.updateChart(vm.month);
      vm.$refs.catchart.updateChart(vm.month);
      vm.getHistorical();
    },
    getYears() {
      const vm = this;
      let currentYear = new Date().getFullYear();
      if(!vm.year) {
        vm.year = currentYear;
      }
      let startYear = 2019;
      let yearslist = [];  
      while ( startYear <= currentYear ) {
          yearslist.push(startYear++);
      }   
      vm.years = yearslist;
    },
    getMonths() {
      const vm = this;
      
      let startMonth = 1;
      let endMonth = new Date().getFullYear() == vm.year ? new Date().getMonth() + 1 : 12;
      if(!vm.month) {
        // vm.month = endMonth;
      }
      let monthlist = [];  
      while ( startMonth <= endMonth ) {
          monthlist.push(startMonth++);
      }   
      
      vm.months = monthlist;
    }
  },
  mounted() {
    const vm = this;
    vm.id = vm.$route.params.id;
    vm.getYears();
    vm.getMonths();
    vm.getHistorical(); 
  }
}
</script>

<style lang="css" scoped>
</style>


// WEBPACK FOOTER //
// src/views/consultor-externo/consultor-externo-historico.vue